






















import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import BaseIcon from "@/components/BaseIcon";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFundraisingFinished",
  components: { BaseIcon, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
